import { gql } from '@apollo/client';

export const GET_PROCUREMENT_MANAGERS = gql(/* GraphQL */ `
    query GetAllProcurementManagers {
        getAllProcurementManagers {
            manager {
                id
                firstName
                lastName
                email
                faxNo
                mobileNo {
                    dialingCode
                    countryCode
                    number
                }
                telNo {
                    dialingCode
                    countryCode
                    number
                }
                speedDial
                designation
            }
            executive {
                id
                firstName
                lastName
                email
                faxNo
                mobileNo {
                    dialingCode
                    countryCode
                    number
                }
                telNo {
                    dialingCode
                    countryCode
                    number
                }
                speedDial
                designation
            }
            productCategories {
                id
                name
                benchmarkMargin
                productCount
            }
        }
    }
`);

export const GET_PROCUREMENT_MANAGERS_FILTER = gql(/* GraphQL */ `
    query GetProcurementManagersFilter {
        getAllProcurementManagers {
            manager {
                id
                firstName
                lastName
            }
        }
    }
`);

export default GET_PROCUREMENT_MANAGERS;
